<template>
    <div class="gradebook">
        <!-- {{this.$route.params.payload}} -->
        <!-- <pre>{{this.gradebook_data}}</pre> -->
        <div class="width-66 width-sm-100 mx-auto">
            <div class="editable_report_block" :class="{hidden: savePreview}">
                <div class="grade-block border-top">
                    <div class="student-info">
                        <h4>{{student_name}}</h4>
                        <div class="grade-badge">
                            <b>Marks(in %):</b>
                            <p class="grade">{{total_mark_obtained}}</p>
                        </div>
                    </div>
                    <vs-row class="my-2">
                        <vs-col class="px-1" vs-lg="6" vs-sm="12" vs-xs="12">
                            <vs-row>
                                <vs-col class="px-1" vs-lg="6" vs-sm="12" vs-xs="12">
                                    <b>Course:</b>
                                </vs-col>
                                <vs-col class="px-1" vs-lg="6" vs-sm="12" vs-xs="12">
                                    <p>{{course_name}}</p>
                                </vs-col>
                            </vs-row>
                        </vs-col>
                        <vs-col class="px-1" vs-lg="6" vs-sm="12" vs-xs="12">
                            <vs-row>
                                <vs-col class="px-1" vs-lg="6" vs-sm="12" vs-xs="12">
                                    <b>School:</b>
                                </vs-col>
                                <vs-col class="px-1" vs-lg="6" vs-sm="12" vs-xs="12">
                                    <p>{{school_name}}</p>
                                </vs-col>
                            </vs-row>
                        </vs-col>
                        <vs-col class="px-1" vs-lg="6" vs-sm="12" vs-xs="12">
                            <vs-row>
                                <vs-col class="px-1" vs-lg="6" vs-sm="12" vs-xs="12">
                                    <b>Course Instructor:</b>
                                </vs-col>
                                <vs-col class="px-1" vs-lg="6" vs-sm="12" vs-xs="12">
                                    <p>{{teacher_name}}</p>
                                </vs-col>
                            </vs-row>
                        </vs-col>
                        <vs-col class="px-1" vs-lg="6" vs-sm="12" vs-xs="12">
                            <vs-row>
                                <vs-col class="px-1" vs-lg="6" vs-sm="12" vs-xs="12">
                                    <b>Grade:</b>
                                </vs-col>
                                <vs-col class="px-1" vs-lg="6" vs-sm="12" vs-xs="12">
                                    <p>{{final_result_grade}}</p>
                                </vs-col>
                            </vs-row>
                        </vs-col>
                    </vs-row>
                </div>
                
                <vs-collapse class="grade-block">
                    <vs-collapse-item>
                        <div slot="header">
                            Attendance
                        </div>
                        <div class="flex sm:flex-wrap justify-between">
                            <div class="sm:w-3/4 w-full">
                                <div class="each-grade" v-for="(details, index) in attendance_details" :key="index">
                                    <b class="mr-4">Marks Obtained:</b>
                                    <div class="number-holder">
                                        <p>{{Number(details.attendance.marks_obtained)}}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </vs-collapse-item>
                </vs-collapse>
                <vs-collapse class="grade-block">
                    <vs-collapse-item>
                        <div slot="header">
                            Exam Result
                        </div>
                        <div class="flex sm:flex-wrap justify-between">
                            <div class="sm:w-3/4 w-full">
                            <!-- {{exam_details}} -->
                                <div class="each-grade" v-for="(details, index) in exam_details[0]" :key="index">
                                    <b>{{details.assignment_title}}</b>
                                     <!-- <br>
                                    <b class="mr-4"> Marks Obtained:</b> -->
                                    <div class="number-holder">
                                        <p>{{Number(details.marks_obtained)}}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </vs-collapse-item>
                </vs-collapse>
                <vs-collapse class="grade-block">
                    <vs-collapse-item>
                        <div slot="header">
                            Homework
                        </div>
                        <div class="flex sm:flex-wrap justify-between">
                            <div class="sm:w-3/4 w-full">
                                <div class="each-grade" v-for="(details, index) in homework_details[0]" :key="index">
                                     <b>{{details.assignment_title}}</b>
                                     <!-- <br>
                                    <b class="mr-4"> Marks Obtained:</b> -->
                                    <div class="number-holder">
                                        <p>{{Number(details.marks_obtained)}}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </vs-collapse-item>
                </vs-collapse>
                <vs-collapse class="grade-block">
                    <vs-collapse-item>
                        <div slot="header">
                            Report
                        </div>
                        <div>
                        <!-- <pre>{{report_details}}</pre> -->
                        <vs-row v-for="(reportItem, index) in report_details" :key="index">
                            <vs-col class="p-1" vs-w="12">
                            <b class="mr-4">
                                {{reportItem.question_title}}
                            </b>
                            <p>{{reportItem.question_answer}}</p>
                            <p>{{reportItem.feedback_text}}</p>
                            </vs-col>
                        </vs-row>
                        </div>
                    </vs-collapse-item>
                </vs-collapse>
                 <div class="grade-block border-top feedback-block">
                    <div class="header p-4">
                    <span>Result Status </span>
                    <v-select
                    class="w-full finall_result"
                    label="text"
                    :reduce="(option) => option.text"
                    :options="[
                        {id:1,text:'Qualified'},
                        {id:2,text:'Disqualified'}
                    ]"
                    v-model="final_result"
                    :clearable="false"
                    data-vv-name="final_result"
                    name="final_result"
                    ></v-select>
                    <!-- {{final_result}} -->

                     <span>Grade </span>
                     <vs-input
                     class="finall_grade"
                     label-placeholder=""
                     v-model="final_result_grade"
                     style="display:inline-block"/>
                     <!-- {{final_result_grade}} -->

                    </div>
                </div>
                <div class="grade-block border-top feedback-block">
                    <div class="header p-4">
                        <p>Teacher's Feedback</p>
                    </div>
                    <div class="my-4 p-4">
                        <vs-textarea v-model="teacher_feedback"></vs-textarea>
                        <!-- {{teacher_feedback}} -->
                    </div>
                </div>
                <div class="text-center pb-4">
                    <vs-button @click="saveAndPreview()">Save and Preview</vs-button>
                </div>
            </div>

            <div class="preview-holder" :class="{show: savePreview}">
                <div class="sm:flex flex-wrap justify-between">
                    <div>
                        <div class="logo_wrapper">
                            <h3 style="color: #41cfdd;" class="mb-2">{{school_name}}</h3>
                        </div>
                        <p>{{school_address}}</p>
                    </div>
                    <div>
                        <h4 class="mb-2">Report Card</h4>
                        <div>
                            <label>Date: </label>
                            <strong>{{report_date | moment("DD/MM/YYYY")}}</strong>
                        </div>
                    </div>
                </div>
                <vs-divider />

                <div class="sm:flex flex-wrap justify-between">
                    <div class="mb-4 sm:mb-0">
                        <h5 class="mb-2">Student Details:</h5>
                         <div>
                            <label>Name: </label>
                            <span> {{student_name}}</span>
                        </div>
                        <div>
                            <label>Instructor: </label>
                            <span> {{teacher_name}}</span>
                        </div>
                        <div>
                            <label>Course: </label>
                            <span> {{course_name}}</span>
                        </div>
                    </div>
                    <div>
                        <h5 class="mb-2">Report Details:</h5>                        
                        <div>
                            <label>Marks: </label>
                            <span>{{total_mark_obtained}}</span>
                        </div>
                        <div>
                            <label>Grade: </label>
                            <span>{{final_result_grade}}</span>
                        </div>
                    </div>
                </div>

                <div class="cstm_vuexy_table my-4">
                    <table class="w-full marksheet-table" style="border-collapse: collapse">
                         <tbody>
                            <tr>
                                <th>Name</th>
                                <th>Gradation Component Type</th>
                                <th>Marks</th>
                                <th>( % )</th>
                            </tr>

                            <tr v-for="(details, index) in attendance_details" :key="index">
                                <td>Attendance Report</td>
                                <td><b>Attendance</b></td>
                                <td>
                                    {{details[Object.keys(details)[0]].marks_obtained}}/{{details[Object.keys(details)[0]].total_mark}}
                                </td>
                                <td> {{ calculatePercentage(details[Object.keys(details)[0]]) }} </td>
                            </tr>

                            <tr v-for="(details, index) in exam_details[0]" :key="index">
                                <td>{{details.assignment_title}}</td>
                                <td><b>Exam</b></td>
                                <td>{{Number(details.marks_obtained)}}/{{Number(details.total_mark)}}</td>
                                <td>{{calculatePercentage(details)}}</td>
                            </tr>

                           <tr v-for="(details, index) in homework_details[0]" :key="index">
                                <td>{{details.assignment_title}}</td>
                                <td><b>Homework</b></td>
                                <td>{{Number(details.marks_obtained)}}/{{Number(details.total_mark)}}</td>
                                 <td>{{calculatePercentage(details)}}</td>
                            </tr>
                        </tbody>
                        <tfoot>
                            <tr>
                                <td>
                                    <b style="margin-right:10px">Result : <span class="passed"> {{final_result}} </span></b>
                                    <b>Grade : <span class="passed"> {{final_result_grade}} </span></b>
                                </td>
                                <td colspan="2"><b>Total:</b></td>
                                <td>{{total_mark_obtained}}</td>
                            </tr>
                        </tfoot>
                    </table>

                    <vs-divider />

                    <h5 class="mb-2">Report:</h5>
                    <div>
                        <!-- <pre>{{report_details}}</pre> -->
                        <vs-row v-for="(reportItem, index) in report_details" :key="index">
                            <vs-col class="p-1" vs-w="12">
                            <b class="mr-4">
                                {{reportItem.question_title}}
                            </b>
                            <p>{{reportItem.question_answer}}</p>
                            <p>{{reportItem.feedback_text}}</p>
                            </vs-col>
                        </vs-row>
                    </div>

                    <vs-divider />

                    <div class="">
                        <h5>Teacher Feedback</h5>
                        <p>{{teacher_feedback}}</p>
                    </div>
                    <!-- <p><b>N.B:</b> Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p> -->
                </div>
                <div class="text-center pb-4">
                    <!-- <vs-button class="mx-1" type="border" @click="savePreview = false">Go Back</vs-button> -->
                    <vs-button class="mx-1" @click="generateReport()">Download</vs-button>
                </div>
            </div>
        </div>

        <vue-html2pdf
        :show-layout="false"
        :float-layout="true"
        :enable-download="true"
        :preview-modal="false"
        :paginate-elements-by-height="1400"
        filename="My_gradebook"
        :pdf-quality="2"
        :manual-pagination="false"
        pdf-format="a4"
        pdf-orientation="portrait"
        pdf-content-width="800px"
 
        @progress="onProgress($event)"
        @hasStartedGeneration="hasStartedGeneration()"
        @hasGenerated="hasGenerated($event)"
        ref="html2Pdf"
    >
        <section slot="pdf-content">
            
             <div class="preview-holder" :class="{show: savePreview}">
                <div class="sm:flex flex-wrap justify-between">
                    <div>
                        <div class="logo_wrapper">
                            <h3 style="color: #41cfdd;" class="mb-2">{{school_name}}</h3>
                        </div>
                        <p>{{school_address}}</p>
                    </div>
                    <div>
                        <h4 class="mb-2">Report Card</h4>
                        <div>
                            <label>Date: </label>
                            <strong>{{report_date | moment("DD/MM/YYYY")}}</strong>
                        </div>
                    </div>
                </div>
                <vs-divider />

                <div class="sm:flex flex-wrap justify-between">
                    <div class="mb-4 sm:mb-0">
                        <h5 class="mb-2">Student Details:</h5>
                         <div>
                            <label>Name: </label>
                            <span> {{student_name}}</span>
                        </div>
                        <div>
                            <label>Instructor: </label>
                            <span> {{teacher_name}}</span>
                        </div>
                        <div>
                            <label>Course: </label>
                            <span> {{course_name}}</span>
                        </div>
                    </div>
                    <div>
                        <h5 class="mb-2">Report Details:</h5>                        
                        <div>
                            <label>Marks: </label>
                            <span>{{total_mark_obtained}}</span>
                        </div>
                        <div>
                            <label>Grade: </label>
                            <span>{{final_result_grade}}</span>
                        </div>
                    </div>
                </div>

                <div class="cstm_vuexy_table my-4">
                    <table class="w-full marksheet-table" style="border-collapse: collapse">
                          <tbody>
                            <tr>
                                <th>Name</th>
                                <th>Gradation Component Type</th>
                                <th>Marks</th>
                                <th>( % )</th>
                            </tr>

                            <tr v-for="(details, index) in attendance_details" :key="index">
                                <td>Attendance Report</td>
                                <td><b>Attendance</b></td>
                                <td>
                                    {{details[Object.keys(details)[0]].marks_obtained}}/{{details[Object.keys(details)[0]].total_mark}}
                                </td>
                                <td> {{ calculatePercentage(details[Object.keys(details)[0]]) }} </td>
                            </tr>

                            <tr v-for="(details, index) in exam_details[0]" :key="index">
                                <td>{{details.assignment_title}}</td>
                                <td><b>Exam</b></td>
                                <td>{{Number(details.marks_obtained)}}/{{Number(details.total_mark)}}</td>
                                <td>{{calculatePercentage(details)}}</td>
                            </tr>

                           <tr v-for="(details, index) in homework_details[0]" :key="index">
                                <td>{{details.assignment_title}}</td>
                                <td><b>Homework</b></td>
                                <td>{{Number(details.marks_obtained)}}/{{Number(details.total_mark)}}</td>
                                <td>{{calculatePercentage(details)}}</td>
                            </tr>
                        </tbody>
                        <tfoot>
                            <tr>
                                <td>
                                    <b style="margin-right:10px">Result : <span class="passed"> {{final_result}} </span></b>
                                    <b>Grade : <span class="passed"> {{final_result_grade}} </span></b>
                                </td>
                                <td colspan="2"><b>Total:</b></td>
                                <td>{{total_mark_obtained}}</td>
                            </tr>
                        </tfoot>
                    </table>

                    <vs-divider />

                    
                    <div class="">
                        <h5>Teacher Feedback</h5>
                        <p>{{teacher_feedback}}</p>
                    </div>

                    <vs-divider />

                    <h5 class="mb-2">Report:</h5>
                    <div>
                        <!-- <pre>{{report_details}}</pre> -->
                        <vs-row v-for="(reportItem, index) in report_details" :key="index">
                            <vs-col class="p-1" vs-w="12">
                            <b class="mr-4">
                                {{reportItem.question_title}}
                            </b>
                            <p>{{reportItem.question_answer}}</p>
                            <p>{{reportItem.feedback_text}}</p>
                            </vs-col>
                        </vs-row>
                    </div>

                    <!-- <p><b>N.B:</b> Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p> -->
                </div>
                <div class="text-center pb-4">
                    <vs-button class="mx-1" type="border" @click="savePreview = false">Go Back</vs-button>
                    <vs-button class="mx-1" @click="generateReport()">Download</vs-button>
                </div>
            </div>
        </section>
    </vue-html2pdf>


    </div>
</template>

<script>
import vSelect from 'vue-select'
import { studentGradebook, gradebookUpdate, gradebook_download } from '@/api/grade'
import VueHtml2pdf from 'vue-html2pdf'
import axios from 'axios'

export default {
  name: 'gradebook',
  components: {
    vSelect,
    VueHtml2pdf
  },
  data () {
    return {
      report_date:'',
      teacher_name:'',
      school_name:'',
      course_name:'',
      student_name:'',
      school_address:'',
      total_mark_obtained:'',
      teacher_feedback:'',
      attendance_details:[],
      homework_details:[],
      exam_details:[],
      report_details:[],
      gradebook_data:null,
      final_result_grade:null,
      final_result:null,
      feedback: false,
      savePreview: true
    }
  },
  created () {
      
    if (!this.$route.params.payload) {
      this.$router.push({name: 'myCourse'})
    } else {
      this.studentGradebook(this.$route.params.payload)
    }
  },
  mounted () {
  },
  methods: {
    calculatePercentage (data) {
    //   console.log('calculatePercentage', data)
      const total_mark = data.total_mark
      const marks_obtained = data.marks_obtained
      let percentage = 0
      //   console.log(total_mark, marks_obtained)
      if (total_mark && marks_obtained) {
        percentage = (marks_obtained / total_mark) * 100
      }
      return percentage.toFixed(2)
    },
    async generateReport () {

      this.$vs.loading({
        text: 'Generating report, please wait...'
      })

      const {data} = await gradebook_download(this.$route.params.payload)
      const url = data.data.url
      console.log('Gradebook Downoad Link : ', url)
      axios.get(url, { responseType: 'blob' })
        .then(response => {
          const blob = new Blob([response.data], {type:'mime'})
          const link = document.createElement('a')
          link.href = URL.createObjectURL(blob)
          link.download = 'Gradebook.pdf'
          link.click()
          URL.revokeObjectURL(link.href)
        }).catch(console.error)

      setTimeout(() => {
        this.$vs.loading.close()
      }, 2000)
  
    },
    async studentGradebook (payload) {
      try {  
        this.$vs.loading()
        this.attendance_details = []
        this.homework_details = []
        this.exam_details = []
        this.report_details = []
        //const customer_id = this.$store.getters.customerId
        const {data} = await studentGradebook(payload)
        this.gradebook_data = data.data
        const grade_book_detail = data.data.grade_info.grade_book_detail
        if (grade_book_detail.submit_type === 'draft' || !this.gradebook_data.grade_info.is_shared) {
          //This means that gradebook is not yet (Saved & Submitted to student) it is just generated & saved as draft by admin
          //   throw data.data.grade_info.grade_book_detail.submit_type
          throw 'Seems like gradebook not generated yet' 
        }
        
        //   console.log('===================== Grade Book ===========================')
        //   console.log(data)
        this.final_result = this.gradebook_data.grade_info.grade_book_detail.result
        this.final_result_grade = this.gradebook_data.grade_info.grade_book_detail.grade
        this.teacher_feedback = this.gradebook_data.grade_info.grade_book_detail.teacher_feedback
        this.total_mark_obtained = Number(this.gradebook_data.grade_info.grade_book_detail.total_mark_obtained)
        this.course_name = this.gradebook_data.grade_info.course_name.name
        this.teacher_name = this.gradebook_data.grade_info.teacher_name
        this.school_name = this.gradebook_data.grade_info.school_name.brand_company_name
        this.student_name = `${this.gradebook_data.grade_info.client_user_name.first_name  } ${   this.gradebook_data.grade_info.client_user_name.last_name}` 
        this.report_date = this.gradebook_data.grade_info.grade_book_detail.created_at
        this.school_address = `${this.gradebook_data.grade_info.school_name.platform_customer_branches.address1  }, ${  this.gradebook_data.grade_info.school_name.platform_customer_branches.address2}`
        this.school_address = this.school_address.replace(null, '')
        this.report_details = this.gradebook_data.grade_components.reports.filter((x) => {
          return x.question_answer !== null || x.feedback_text
        })

        if (this.gradebook_data.grade_components.attendance) {
          Object.values(this.gradebook_data.grade_components.attendance).forEach((val, key) => {
            this.attendance_details.push(val)
          })
        }

        if (this.gradebook_data.grade_components.Homework) {
          Object.values(this.gradebook_data.grade_components.Homework).forEach((val, key) => {
            this.homework_details.push(val)
          })
        }

        if (this.gradebook_data.grade_components.Exam) {
          Object.values(this.gradebook_data.grade_components.Exam).forEach((val, key) => {
            this.exam_details.push(val)
          })
        }

        // const objEntries = Object.entries(this.gradebook_data.grade_components.Exam)
        // console.log(Object.fromEntries(objEntries))

      //console.log(attendance_details, homework_details, exam_details)
      } catch (e) {
        console.log(e)
        this.$vs.notify({
          title: 'Error',
          text: 'Seems like gradebook not generated yet',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger',
          time: 3000
        })
        
        window.history.back()
        
      } finally {
        this.$vs.loading.close()
      }
      
    },
    async gradebookUpdate () {
      try {
        this.$vs.loading({
          text: 'Updating gradebook...'
        })
        
        const customer_id = this.$store.getters.customerId
        const payload = {
          'grade_book_id': this.gradebook_data.grade_info.grade_book_detail.id,
          'teacher_feedback' : this.teacher_feedback,
          'grade' : this.final_result_grade,
          'result': this.final_result
        }
        const {data} = await gradebookUpdate(customer_id, payload)
        console.log(data)
        this.studentGradebook(this.$route.params.payload)
        this.savePreview = true
        this.$vs.notify({
          title: 'Success',
          text: 'Gradebook updated',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'success',
          time: 3000
        })   
      } catch (e) {
        console.log(e) 
        this.$vs.notify({
          title: 'Error',
          text: e,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger',
          time: 3000
        })     
      } finally {
        this.$vs.loading.close()
      }
    
    },
    saveAndPreview () {
      if (!this.final_result) {
        this.$vs.notify({
          title:'You have not selected final result',
          text: 'Please select student`s final result',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color:'danger',
          time: 3000
        })
      } else if (!this.final_result_grade) {
        this.$vs.notify({
          title:'You have not selected final grade',
          text: 'Please select student`s final grade',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color:'danger',
          time: 3000
        })
      } else {
        this.gradebookUpdate()
      }
     
    }
     
  }
}
</script>

<style>
.passed {
    color: #28c76f;
    text-transform: uppercase;
}
.fail {
    color: #ff0000;
    text-transform: uppercase;
}
</style>

<style scoped>
.finall_result{
    display:inline-block;
    margin-right:20px;
    max-width:145px !important;
    width:145px;
    font-size: 12.5px;
}
.finall_grade{

}
</style>